import {
    ACTION_PROMISE, ACTION_MULTIPLE,
    RESPONSE_STATUS_SUCCESS,
    PRE_LOADER_SHOW, PRE_LOADER_HIDE,
    ALERT_SUCCESS, ALERT_ERROR, ALERT_HIDE
} from '../utils/Constant';

import {empty} from '../utils/Helper';

/**
 * Middleware для обработки сложных action-ов (промисов и множественных действий)
 * Примечание: обработка 401 ошибок делегирована interceptor.js
 */
const MultiAction = store => next => action => {

    if (action !== false) {

        try {

            const [startAction, successAction, failureAction, afterAction] = action.actions;

            switch (action.type) {

                case ACTION_PROMISE :

                    // Показываем индикатор загрузки
                    store.dispatch({type: PRE_LOADER_SHOW});

                    // Диспатчим стартовое действие
                    store.dispatch({...action, type: startAction});

                    action.promise.then((data) => {

                        // Диспатчим успешное действие с данными
                        store.dispatch({type: successAction, data,});

                        // Обрабатываем afterAction если он есть
                        if (typeof afterAction === 'undefined') {
                            actionAlert(store, data, action.duration);
                            store.dispatch({type: PRE_LOADER_HIDE});
                        }

                        return data;

                    }, (error) => {
                        // Обработка ошибок
                        
                        if(typeof error.response === 'undefined') {
                            // Ошибка без ответа сервера
                            actionAlert(store, null, action.duration);
                        } else {
                            // ВАЖНО: Убрана прямая обработка 401 ошибки
                            // Эту логику полностью берет на себя interceptor.js
                            // который может попытаться обновить токен
                            
                            // Только диспатчим failure action если он определен
                            if(!empty(failureAction)) {
                                store.dispatch({type: failureAction, error});
                            }
                            // Показываем сообщение об ошибке
                            actionAlert(store, error.response.data, action.duration);
                        }

                        // Скрываем индикатор загрузки
                        store.dispatch({type: PRE_LOADER_HIDE});
                        return error;

                    }).then((result) => {
                        // Обработка after action
                        if (typeof afterAction !== 'undefined') {
                            store.dispatch({type: PRE_LOADER_HIDE});
                            return actionAfter(store, afterAction, result);
                        }
                        return result;
                    });
                    break;

                case ACTION_MULTIPLE:
                    try {
                        // Обработка множественных действий
                        store.dispatch({...action, type: startAction});
                        store.dispatch({...action, type: successAction});
                        actionAfter(store, afterAction);
                    } catch (e) {
                        actionAfter(store, failureAction);
                    }
                    break;
                default :
                    // Передаем действие следующему middleware
                    return next(action);
            }

        } catch (e) {
            // В случае ошибки передаем действие следующему middleware
            return next(action);
        }
    }
};

/**
 * Показывает алерт на основе полученных данных
 * @param store - Redux store
 * @param data - Данные для отображения в алерте
 * @param duration - Длительность показа алерта
 */
export function actionAlert(store, data, duration = 4500) {

    let alert = {
        type: ALERT_ERROR,
        message: 'Error, please try again.'
    };

    if (!empty(data)) {
        if(isSuccess(data)) {
            alert.type = ALERT_SUCCESS;
        }
        alert.message = data.message;
    }

    store.dispatch({
        type: alert.type,
        data: {
            content: alert.message,
            duration
        }
    });

    // Автоматически скрываем алерт через заданное время
    setTimeout(() => {
        store.dispatch({type: ALERT_HIDE});
    }, duration);

}

/**
 * Проверяет, является ли ответ успешным
 * @param data - Данные ответа
 * @returns {boolean} - true если ответ успешный
 */
function isSuccess(data) {
    return !empty(data) && data.status === RESPONSE_STATUS_SUCCESS;
}

/**
 * Выполняет последующее действие после основной операции
 * @param store - Redux store
 * @param action - Действие для выполнения
 * @param data - Данные для передачи в действие
 */
export function actionAfter(store, action, data) {
    if (typeof action !== 'undefined') {
        if (action.type === ACTION_PROMISE) {
            store.dispatch(action);
        } else {
            store.dispatch({
                type: action,
                data,
            })
        }
    }
}

export default MultiAction;